import React from 'react';
import useSearchStore from '../_Global/SearchStore';

interface SpellingSuggestionConfig {
    suggestion: string;
}

function SpellingSuggestion({suggestion}: SpellingSuggestionConfig) {
    const setFunnelbackQueryParameters = useSearchStore((state) => state.setFunnelbackQueryParameters);
    const setUserSearchTerm = useSearchStore((state) => state.setUserSearchTerm);

    const handleSuggestion = () => {
        setUserSearchTerm(suggestion);
        setFunnelbackQueryParameters({
            query: suggestion,
        });
    };

    if (suggestion) {
        return (
            <p className="body-default">
                Did you mean{' '}
                <span className="search-suggestion body-link" onClick={handleSuggestion}>
                    {suggestion}
                </span>
                ?
            </p>
        );
    }
}

/**
 * Create the markup for spelling suggestion.
 */
export default React.memo(SpellingSuggestion);
